import axios from 'axios';

interface ApiResponse {
    data: [];
    totalPage: number;
    totalResultat: number;
}

export const postFicheParametrage = async (parametrage) => {
    return await axios.post(`/arretTravail/parametrage`, parametrage);
};

export const postWorkStoppage = async (parametrage) => {
    return await axios.post('/workstoppage', parametrage);
};

export const getRematerialization = (store) => {
    // Use axios to make a POST request and handle the response as binary data (blob)
    return axios.post('/rematerialization', store, {
        responseType: 'blob', // Important for handling binary data such as PDFs
    });
};

export const getWorkStoppageCompagnie = ({ idContract, startDate }) => {
    // Use axios to make a POST request and handle the response as binary data (blob)
    return axios.post('/workstoppage/compagnie', { idContract, startDate });
};
// api/workstoppage/compagnie

export function getWorkStoppageHistory(page, limit, sort, search): Promise<ApiResponse> {
    return axios.get(`/arret_travail/history`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}

export function getWorkStoppageHistoryById(id) {
    return axios.get(`/arret_travail/` + id);
}

export function getContract(codContract: string) {
    return axios.get(`/contrats/${codContract}`);
}

export function getContractsPrev() {
    return axios.get(`/contrats/prevoyance`);
}

export const sendMessageToResponsable = (data) => {
    // Use axios to make a POST request and handle the response as binary data (blob)
    return axios.post('/workstoppage/send_message', data);
};
